import React, { useEffect } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import logo from '../assets/images/logo.svg'
import { BlurElipse1 } from './utils/blurElipse';
import { scroolToElement } from './utils/scrollTo';

export const Header = () => {

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    useEffect(() => {
        document.addEventListener('scroll', handleScroll);
    }, [])

    const handleScroll = (event: Event) => {

        const top = window.pageYOffset || document.documentElement.scrollTop;
        const header = document.querySelector('#header-wrapper')
        const width = window.innerWidth || document.documentElement.clientWidth|| document.body.clientWidth;
        if(header && width){
            if(width > 768) {
                if(top >= 100){
                    header.classList.add('scrolled')
                } else {
                    header.classList.remove('scrolled')
                }
            } else {
                header.classList.add('scrolled')
            }
        }
    }

    return (
        <Navbar  data-aos="fade-down" expand="lg" id='navbar_el' className=' p-0 my-2 container'>
            <BlurElipse1 />
            <Navbar.Brand onClick={() => scrollToTop()}><img className='m-0 ms-3 ms-md-0' src={logo} alt="logo pickit.cz" /></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" className='me-3 border-0' >
                <span role="button" aria-label="show-nav" ><i className="fa fa-bars fa-2x text-white" aria-label="toggle-icon" aria-hidden="true"></i></span></Navbar.Toggle >
            <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end justify-content-lg-center">
                <Nav className="navbar-nav text-center d-flex align-items-center">
                    <Nav.Link onClick={() => scroolToElement("firstSection")} className="nav-item px-0 px-lg-3 px-xl-4 mt-4 mt-lg-0 my-2 my-lg-0" >Co nabízíme</Nav.Link>
                    <Nav.Link onClick={() => scroolToElement("secondSection")} className="nav-item px-0 px-lg-3 px-xl-4 my-2 my-lg-0">Benefity</Nav.Link>
                    <Nav.Link onClick={() => scroolToElement("thirdSection")} className="nav-item px-0 px-lg-3 px-xl-4 my-2 my-lg-0">Jak to funguje</Nav.Link>
                    <Nav.Link onClick={() => scroolToElement("fifthSection")} className="nav-item px-0 px-lg-3 px-xl-4 my-2 my-lg-0">O nás</Nav.Link>
                    <Nav.Link onClick={() => scroolToElement("contactForm")} className="nav-item px-0 px-lg-3 px-xl-4 my-2 my-lg-0">Kontakt</Nav.Link>
                    <a href="https://admin.pickit.cz" target="_blank" className="nav-item mx-auto"><button className="border rounded-pill ms-lg-5  nav-Nav.Link-last p-0 px-3 py-1 bg-transparent">Přihlásit se</button></a>

                </Nav>
            </Navbar.Collapse>
            <Navbar.Brand className=' d-none d-lg-block'><img className=' me-3 me-lg-4 me-xl-0 opacity-0' src={logo} alt="logo placeholder" /></Navbar.Brand>
        </Navbar>
    )
}
